import isMobileLayout from '../utils/isMobileLayout';
import { useEffect, useState } from 'react';
import AccountAccessPanel from '../components/AccountAccessPanel';

import loginMapBg from '../assets/icons/login-map-bg.png';
function getAccountModeFromHash() {
  const params = new URLSearchParams(
    window.location.hash.slice(1)
  );

  return params.has('activar')
    ? 'activate'
    : params.has('restablecer')
      ? 'reset'
      : null;
}

function Login({ setLogueado }) {
  const [accountMode, setAccountMode] =
    useState(getAccountModeFromHash);

  useEffect(() => {
    const update = () =>
      setAccountMode(getAccountModeFromHash());

    window.addEventListener('hashchange', update);

    return () =>
      window.removeEventListener('hashchange', update);
  }, []);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(isMobileLayout);

useEffect(() => {
  const checkMobile = () => {
    setIsMobile(isMobileLayout());
  };

  checkMobile();

  window.addEventListener('resize', checkMobile);

  return () => {
    window.removeEventListener('resize', checkMobile);
  };
}, []);

  async function handleLogin(e) {
    e.preventDefault();

    try {
      setLoading(true);

      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });

      const data = await response.json();

      if (data.token) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        setLogueado(true);
      } else {
        alert(data.error || 'Error al iniciar sesión');
      }
    } catch (error) {
      console.error(error);
      alert('No fue posible conectar con el servidor');
    } finally {
      setLoading(false);
    }
  }
return (
  <div style={isMobile ? pageMobileStyle : pageStyle}>
    {!isMobile && (
      <section style={leftPanelStyle}>
        {/* <div style={mapGlowStyle} /> */}
        {/* <RouteGraphic /> */}

        <div style={leftContentStyle}>
          <BrandLogo large />

          <h1 style={heroTitleStyle}>
            Centro de Control Inteligente
            <br />
            para <span style={blueText}>Vehículos y Activos</span>
          </h1>

          <p style={heroTextStyle}>
            Monitoreo en tiempo real, seguridad avanzada y tecnología que mueve
            tu operación hacia el futuro.
          </p>

          <div style={featuresStyle}>
            <Feature icon="⌖" title="Monitoreo GPS" text="Ubicación y estado en tiempo real." />
            <Feature icon="⬡" title="Seguridad Inteligente" text="Alertas en tiempo real y geocercas." />
            <Feature icon="▥" title="Telemetría Avanzada" text="Datos precisos para mejores decisiones." />
            <Feature icon="☁" title="Plataforma Confiable" text="Infraestructura segura y escalable." />
          </div>

          <div style={statsStyle}>
            <Stat icon="▣" number="12.500+" label="Eventos procesados" />
            <Stat icon="▦" number="85+" label="Empresas conectadas" />
            <Stat icon="◇" number="99.98%" label="Disponibilidad" />
            <Stat icon="⌁" number="24/7" label="Monitoreo activo" />
          </div>
        </div>
      </section>
    )}

    <section style={isMobile ? rightPanelMobileStyle : rightPanelStyle}>
   <div style={isMobile ? {
  ...loginCardStyle,
  boxSizing: 'border-box',
  marginTop: 0,
  marginBottom: 0,
  padding: '16px',
  borderRadius: '18px'
} : loginCardStyle}>
        <BrandLogo />
          {accountMode ? (
            <AccountAccessPanel
              mode={accountMode}
              onBack={() => {
                window.history.replaceState(
                  null,
                  '',
                  window.location.pathname
                );
                setAccountMode(null);
              }}
            />
          ) : <>
          {new URLSearchParams(
            window.location.search
          ).get('cuenta') === 'activada' && (
            <p role="status" style={{
              color: '#bbf7d0',
              textAlign: 'center'
            }}>
              Cuenta activada. Ingresa con tu correo y contraseña.
            </p>
          )}

          {new URLSearchParams(
            window.location.search
          ).get('cuenta') === 'recuperada' && (
            <p role="status" style={{
              color: '#bbf7d0',
              textAlign: 'center'
            }}>
              Contraseña actualizada. Ya puedes ingresar.
            </p>
          )}

          <h2 style={welcomeStyle}>Bienvenido</h2>

          <p style={welcomeTextStyle}>
            Accede a tu plataforma de monitoreo
          </p>

          <form onSubmit={handleLogin}>
            <label style={labelStyle}>Correo electrónico</label>

            <div style={inputWrapperStyle}>
              <span style={inputIconStyle}>✉</span>
              <input
                type="email"
                placeholder="correo@empresa.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={inputStyle}
              />
            </div>

            <label style={labelStyle}>Contraseña</label>

            <div style={inputWrapperStyle}>
              <span style={inputIconStyle}>▢</span>
              <input
                type="password"
                placeholder="Ingresa tu contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={inputStyle}
              />
            </div>

            <div style={optionsStyle}>
              <label style={rememberStyle}>
                <input type="checkbox" />
                Recordarme
              </label>

              <button
                type="button"
                style={{
                  ...linkStyle,
                  background: 'none',
                  border: 0
                }}
                onClick={() => setAccountMode('forgot')}
              >
                ¿Olvidaste tu contraseña?
              </button>
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                ...buttonStyle,
                opacity: loading ? 0.75 : 1,
                cursor: loading ? 'not-allowed' : 'pointer'
              }}
            >
              {loading ? 'INGRESANDO...' : 'INGRESAR  →'}
            </button>
          </form>

          <button
            type="button"
            onClick={() => setAccountMode('register')}
            style={{
              ...linkStyle,
              display: 'block',
              margin: '18px auto',
              background: 'none',
              border: 0
            }}
          >
            Crear cuenta
          </button>
          </>}

       <div style={secureTextStyle}>🔒 Plataforma segura</div>

<a
  href="https://maccez.com/politica-de-privacidad-divi/"
  target="_blank"
  rel="noopener noreferrer"
  style={{
    display: 'block',
    marginTop: '12px',
    padding: '8px',
    textAlign: 'center',
    color: '#93c5fd',
    fontSize: '13px',
    textDecoration: 'underline'
  }}
>
  Política de privacidad
</a>
        </div>
      </section>
    </div>
  );
}
function BrandLogo({ large }) {
  return (
    <div
      role="img"
      aria-label="DIVI"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        width: large ? '216px' : '180px',
        maxWidth: '100%',
        margin: large ? '0 0 20px' : '0 auto 24px'
      }}
    >
      <svg
        viewBox="0 0 316 100"
        aria-hidden="true"
        focusable="false"
        style={{
          display: 'block',
          width: large ? '146px' : '120px',
          height: 'auto',
          flex: '1 1 0',
          minWidth: 0
        }}
      >
        <path
          d="M0 0H55C90 0 112 21 112 50S90 100 55 100H0ZM20 20V80H54C78 80 92 69 92 50S78 20 54 20Z"
          fill="#ffffff"
          fillRule="evenodd"
        />
        <path d="M126 0H146V100H126Z" fill="#ffffff" />
        <path
          d="M160 0H185L221 72L257 0H282L231 100H211Z"
          fill="#1688ff"
        />
        <path d="M296 0H316V100H296Z" fill="#1688ff" />
      </svg>

      <svg
        viewBox="0 0 200 200"
        fill="none"
        aria-hidden="true"
        focusable="false"
        style={{
          display: 'block',
          width: large ? '58px' : '48px',
          height: 'auto',
          flexShrink: 0
        }}
      >
        <path
          d="M27 89A74 74 0 0 1 100 27"
          stroke="#ffffff"
          strokeWidth="12"
        />
        <path
          d="M26 102A74 74 0 0 0 96 174M108 174A74 74 0 0 0 168 85"
          stroke="#1688ff"
          strokeWidth="12"
        />
        <path d="M43 111L129 65L82 114Z" fill="#ffffff" />
        <path d="M82 114L129 65L93 156Z" fill="#1688ff" />
        <circle cx="145" cy="55" r="10" fill="#1688ff" />
        <g
          stroke="#1688ff"
          strokeWidth="5"
          strokeLinecap="round"
        >
          <path d="M130 29A43 43 0 0 1 173 62" />
          <path d="M130 13A59 59 0 0 1 188 58" />
        </g>
      </svg>
    </div>
  );
}

function Feature({ icon, title, text }) {
  return (
    <div style={featureStyle}>
      <div style={featureIconStyle}>{icon}</div>
      <div>
        <strong>{title}</strong>
        <p style={featureTextStyle}>{text}</p>
      </div>
    </div>
  );
}

function Stat({ icon, number, label }) {
  return (
    <div style={statItemStyle}>
      <div style={statIconStyle}>{icon}</div>
      <strong>{number}</strong>
      <span>{label}</span>
    </div>
  );
}

function RouteGraphic() {
  return (
    <div style={routeBoxStyle}>
      <div style={cityGridStyle} />
      <svg style={routeSvgStyle} viewBox="0 0 600 720">
        <path
   d="M410 50 C335 110 455 165 350 245 C275 305 385 390 270 470 C175 545 120 610 70 675"
          fill="none"
          stroke="#178bff"
          strokeWidth="10"
          strokeLinecap="round"
          style={{ filter: 'drop-shadow(0 0 18px #178bff)' }}
        />
        <circle cx="380" cy="35" r="18" fill="#178bff" />
        <circle cx="340" cy="245" r="10" fill="#60a5fa" />
        <circle cx="280" cy="470" r="10" fill="#60a5fa" />
        <circle cx="180" cy="680" r="16" fill="#178bff" />
        <rect x="130" y="610" width="80" height="42" rx="8" fill="#dbeafe" opacity="0.65" />
      </svg>
    </div>
  );
}

const pageStyle = {
  height: '100vh',
  width: '100vw',
  display: 'grid',
  gridTemplateColumns: '1.42fr 0.88fr',
  background: '#020617',
  fontFamily: 'Inter, Arial, sans-serif',
  color: '#fff',
  overflow: 'hidden'
};
const pageMobileStyle = {
  height: '100dvh',
  minHeight: 0,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  paddingTop: 'calc(env(safe-area-inset-top, 0px) + 12px)',
  paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 12px)',
  background: '#020617',
  fontFamily: 'Inter, Arial, sans-serif',
  color: '#fff',
  overflowX: 'hidden',
  overflowY: 'auto',
  WebkitOverflowScrolling: 'touch'
};
const leftPanelStyle = {
  position: 'relative',
  height: '100vh',
  padding: '22px 48px 18px',
  overflow: 'hidden',

  backgroundImage: `
    linear-gradient(
      90deg,
      rgba(2,6,23,.95) 0%,
      rgba(2,6,23,.75) 35%,
      rgba(2,6,23,.25) 65%,
      rgba(2,6,23,.10) 100%
    ),
    url(${loginMapBg})
  `,

  backgroundSize: 'cover',
  backgroundPosition: 'center right',
  backgroundRepeat: 'no-repeat'
};
const leftPanelMobileStyle = {
  position: 'relative',
  width: '100%',
  minHeight: 'auto',
  padding: '20px',
  overflow: 'visible',

  backgroundImage: `
    linear-gradient(
      180deg,
      rgba(2,6,23,.95) 0%,
      rgba(2,6,23,.75) 100%
    ),
    url(${loginMapBg})
  `,

  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat'
};
const mapGlowStyle = {
  position: 'absolute',
  inset: 0,
  background:
    'linear-gradient(90deg, rgba(2,6,23,.97) 0%, rgba(2,6,23,.75) 45%, rgba(2,6,23,.22) 100%)',
  zIndex: 2
};

const routeBoxStyle = {
  position: 'absolute',
  inset: 0,
  zIndex: 1
};

const cityGridStyle = {
  position: 'absolute',
  inset: '0 0 0 20%',
  opacity: 0.62,
  background:
    'repeating-linear-gradient(25deg, rgba(37,99,235,.26) 0 2px, transparent 2px 38px), repeating-linear-gradient(115deg, rgba(148,163,184,.16) 0 1px, transparent 1px 34px)',
  transform: 'perspective(760px) rotateX(58deg) rotateZ(-8deg)',
  transformOrigin: 'center',
  borderRadius: '40px'
};

const routeSvgStyle = {
  position: 'absolute',
  right: '2%',
  top: '4%',
  width: '62%',
  height: '88%',
  opacity: 0.96
};

const leftContentStyle = {
  position: 'relative',
  zIndex: 3,
  maxWidth: '760px',
  height: '100%',
  display: 'block',
  paddingTop: '8px',
  transform: 'none'
};

const heroTitleStyle = {
  fontSize: '38px',
  lineHeight: 1.08,
  margin: '4px 0 0',
  fontWeight: 900,
  letterSpacing: '-1.4px'
};
const blueText = {
  color: '#2f8cff'
};

const heroTextStyle = {
  marginTop: '10px',
  maxWidth: '620px',
  color: '#dbeafe',
  fontSize: '15px',
  lineHeight: 1.35
};

const featuresStyle = {
  marginTop: '14px',
  display: 'grid',
  gap: '6px'
};

const featureStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '14px'
};

const featureIconStyle = {
  width: '34px',
  height: '34px',
  borderRadius: '11px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(15,23,42,.72)',
  border: '1px solid rgba(96,165,250,.32)',
  color: '#2f8cff',
  fontSize: '16px'
};

const featureTextStyle = {
  margin: '2px 0 0',
  color: '#cbd5e1',
  fontSize: '12px'
};

const statsStyle = {
  marginTop: '22px',
  transform: 'translateY(10px)',
  maxWidth: '650px',
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  border: '1px solid rgba(96,165,250,.32)',
  borderRadius: '16px',
  background: 'rgba(2,6,23,.55)',
  backdropFilter: 'blur(14px)',
  overflow: 'hidden'
};

const statItemStyle = {
  padding: '8px 8px',
  textAlign: 'center',
  borderRight: '1px solid rgba(96,165,250,.14)',
  display: 'grid',
  gap: '2px',
  fontSize: '11px',
  color: '#dbeafe'
};

const statIconStyle = {
  color: '#2f8cff',
  fontSize: '17px'
};

const rightPanelStyle = {
  position: 'relative',
  height: '100vh',
  padding: '24px 38px',
  paddingTop: '0',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',

  background:
    'radial-gradient(circle at 50% 50%, rgba(37,99,235,.14), transparent 40%), #020617',

  overflow: 'hidden'
};

const rightPanelMobileStyle = {
  position: 'relative',
  width: '100%',
  flex: '1 0 auto',
  boxSizing: 'border-box',
  padding: '0 20px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  background: '#020617',
  overflow: 'visible'
};

const loginCardStyle = {
  width: '100%',
  maxWidth: '500px',

  marginTop: '35px',

  padding: '25px 42px',
  borderRadius: '32px',

  background: 'rgba(7,16,32,.78)',

  border: '1px solid rgba(96,165,250,.42)',

  boxShadow:
    '0 0 0 1px rgba(255,255,255,.03), 0 0 38px rgba(37,99,235,.25), 0 35px 90px rgba(0,0,0,.65)',

  backdropFilter: 'blur(22px)'
};

const welcomeStyle = {
  textAlign: 'center',
  fontSize: '30px',
  margin: '0 0 6px'
};

const welcomeTextStyle = {
  textAlign: 'center',
  color: '#cbd5e1',
  marginBottom: '28px',
  fontSize: '14px'
};

const labelStyle = {
  display: 'block',
  marginBottom: '8px',
  color: '#e2e8f0',
  fontSize: '14px'
};

const inputWrapperStyle = {
  height: '50px',
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '0 16px',
  marginBottom: '20px',
  borderRadius: '14px',
  border: '1px solid rgba(148,163,184,.35)',
  background: 'rgba(2,6,23,.35)'
};

const inputIconStyle = {
  color: '#cbd5e1',
  fontSize: '18px'
};

const inputStyle = {
  width: '100%',
  border: 'none',
  outline: 'none',
  background: 'transparent',
  color: '#fff',
  fontSize: '15px'
};

const optionsStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '24px',
  color: '#cbd5e1',
  fontSize: '13px'
};

const rememberStyle = {
  display: 'flex',
  gap: '8px',
  alignItems: 'center'
};

const linkStyle = {
  color: '#2f8cff',
  cursor: 'pointer'
};

const buttonStyle = {
  width: '100%',
  height: '58px',
  border: 'none',
  borderRadius: '14px',
  background: 'linear-gradient(135deg, #168bff, #0b5cff)',
  color: '#fff',
  fontSize: '17px',
  fontWeight: 900,
  letterSpacing: '.5px',
  boxShadow: '0 18px 40px rgba(37,99,235,.45)'
};

const secureTextStyle = {
  marginTop: '26px',
  textAlign: 'center',
  color: '#cbd5e1',
  fontSize: '13px'
};

export default Login;